interface ImmovoxLogoProps {
  size?: number;
  className?: string;
}

/**
 * Immovox monogram.
 * Three architectural volumes form an abstract agency/building silhouette.
 * Kept as inline SVG so it stays sharp at favicon, navigation and footer sizes.
 */
const ImmovoxLogo = ({ size = 24, className }: ImmovoxLogoProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path d="M5 42V24L15 18V42H5Z" fill="currentColor" />
    <path d="M17 42V14L29 5V42H17Z" fill="currentColor" />
    <path d="M31 42V17L43 24V42H31Z" fill="currentColor" />
    <path d="M17 14V9.5L29 1V5L17 14Z" fill="currentColor" opacity=".92" />
  </svg>
);

export default ImmovoxLogo;
